import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide6UKSummary({
  index
}: SlideProps) {
  const benefits = [{
    title: 'Maximize Global Investment',
    desc: 'Extract maximum value from global webinars by repurposing them for the UK market.'
  }, {
    title: 'Local Relevance',
    desc: 'Deliver bite-sized, localized content that resonates with UK dermatologists.'
  }, {
    title: 'Always-On Engagement',
    desc: 'Replace point-in-time events with continuous, multi-channel episodic campaigns.'
  }, {
    title: 'Clear Pathway to Anzupgo',
    desc: 'Build a structured funnel from non-branded scientific education to branded activities.'
  }];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-252">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(2rem,3vw,3rem)] flex-shrink-0" data-id="element-253">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-254">
          Summary
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-255">
          The UK Localization{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-256">Advantage</span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-2 gap-[clamp(1.5rem,3vw,3rem)] min-h-0" data-id="element-257">
        <div className="flex flex-col justify-center gap-6" data-id="element-258">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4 + i * 0.15,
          duration: 0.5
        }} className="flex items-start gap-4" data-id="element-259">
              <div className="mt-1" data-id="element-260">
                <CheckCircle2 className="w-6 h-6 text-[var(--brand-green)]" data-id="element-261" />
              </div>
              <div data-id="element-262">
                <h3 className="text-[var(--fg)] font-bold text-xl mb-1" data-id="element-263">
                  {b.title}
                </h3>
                <p className="text-[var(--muted)] text-base leading-relaxed" data-id="element-264">
                  {b.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 1,
        duration: 0.6
      }} className="bg-[var(--brand-green)] rounded-2xl p-[clamp(2rem,3vw,3rem)] flex flex-col justify-center text-white shadow-xl" data-id="element-265">
          <h3 className="font-bold text-[clamp(1.75rem,2.5vw,2.5rem)] leading-tight mb-4" data-id="element-266">
            Ready to activate the UK market?
          </h3>
          <p className="text-white/90 text-[clamp(1.1rem,1.25vw,1.25rem)] leading-relaxed mb-8" data-id="element-267">
            Transform your next global webinar into a localized, always-on
            engine that drives measurable engagement and builds a robust funnel
            for Anzupgo.
          </p>
          <div className="mt-auto" data-id="element-268">
            <button className="bg-white text-[var(--brand-green)] font-bold py-3 px-8 rounded-full text-lg hover:bg-gray-100 transition-colors" data-id="element-269">
              Start the Conversation
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}